
const environment = {
    test: 'http://127.0.0.1:5001/admin-side-ce210/us-central1/',
    production: 'https://us-central1-admin-side-ce210.cloudfunctions.net/'
}
// const link = environment.test;
  const link = environment.production;
export const functionsLink = {
    getOrbits: `${link}getOrbitsAPI`,
    getAllTrainsOrbits: `${link}getAllTrainsOrbitsAPI`,
    // getDollarValue: `${link}getDollarValueAPI`,
    getDollarValue: `${link}getDollarValueCorsAPI `,
    getNewYearOrbits: `${link}getNewYearOrbitsAPI`,
    //getAllOrbits: `${link}getAllOrbitsSadir`,
    getStartLocation: `${link}getStartLocationAPI`,
    getPrice: `${link}getPriceAPI`,
    saveTravel: `${link}saveTravelCustomersAPI`,
    savePrivateTravel: `${link}savePrivateTravelCustomersAPI`,
    saveTravelTemporary : `${link}saveTravelCustomersTemporaryAPI `,
    editTravel: `${link}editTravelAPI`,
    editSadirTravel : `${link}editSadirTravelAPI`,
    deleteTravel : `${link}deleteTravelAPI`,
    deleteCustomerTravel : `${link}deleteCustomerTravelAPI`,
    getNameCarById: `${link}getNameCarByIdAPI`,
    getNameOrbitById: `${link}getNameOrbitByIdAPI`,
    getCities: `${link}getCitiesAPI`,
    getMyTravels : `${link}getMyTravelsAPI`,
    getTravelNotConfirmedYet : `${link}getTravelNotConfirmedYetAPI`,
    getCarTypes: `${link}getCarTypesAPI`,
    getStartLocationById: `${link}getStartLocationByIdAPI`,
    getInvitationDetails: `${link}getInvitationDetailsAPI2`,
    // getInvitationDetails: `${link}getInvitationDetailsAPI`,
    getSadirInvitationDetails: `${link}getSadirInvitationDetailsByDateAPI`,
    editSadirInvitationDetails: `${link}editSadirInvitationDetailsByDateAPI`,
    fetchSendMessage: `${link}fetchSendMessageAPI`, 
    fetchPaymentDetails: `${link}fetchPaymentDetailsAPI`,
    fetchPaymentDetailsVahavAPI: `${link}fetchPaymentDetailsVahavAPI`,
    fetchPaymentDetailsVahavTestAPI: `${link}fetchPaymentDetailsVahavTestAPI`,
    fetchPaymentDetailsTestEnv: `${link}fetchPaymentDetailsTestEnvAPItest`,
    fetchPaymentDetailsRefund: `${link}fetchPaymentDetailsRefundAPI`, 
    fetchIsConfirmedPaymentDetails :`${link}fetchIsConfirmedPaymentDetailsAPI`,
    getCurrentAgent :`${link}getCurrentAgentAPI`,
    getTermsValue: `${link}getTermsValueCorsAPI `,
    getTrainsTermsValue : `${link}getTrainsTermsValueCorsAPI `,
    getPriceListValue: `${link}getPriceListValueCorsAPI `,
    getairportsAndHours : `${link}getairportsAndHoursAPI`,
    // need update every year
    get2025RangeAPI: `${link}get2025RangeAPI`,
    getCustomerSettingsCorsAPI: `${link}getCustomerSettingsCorsAPI`
}